import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsArrowRepeat, BsThreeDotsVertical } from "react-icons/bs";
import { MdFileDownload } from "react-icons/md";

const initialData = [
    {
        id: "SUB001",
        name: "City Heritage Tours",
        plan: { label: "Basic", color: "secondary" },
        status: { label: "Active", color: "success" },
        startDate: "Jan 1, 2024",
        endDate: "Jan 1, 2025",
        amount: "19.99 USD",
        autoRenew: false,
    },
    {
        id: "SUB002",
        name: "ThrillSeeker Adventures",
        plan: { label: "Premium", color: "purple" },
        status: { label: "Active", color: "success" },
        startDate: "Nov 15, 2023",
        endDate: "Nov 15, 2024",
        amount: "49.99 USD",
        autoRenew: false,
    },
    {
        id: "SUB003",
        name: "Aqua Fun Waterpark",
        plan: { label: "Standard", color: "primary" },
        status: { label: "Cancelled", color: "danger" },
        startDate: "Jun 1, 2023",
        endDate: "May 31, 2024",
        amount: "29.99 USD",
        autoRenew: false,
    },
    {
        id: "SUB004",
        name: "Global Trek Guides",
        plan: { label: "Basic", color: "secondary" },
        status: { label: "Pending Payment", color: "warning" },
        startDate: "Jul 1, 2024",
        endDate: "Aug 1, 2024",
        amount: "19.99 USD",
        autoRenew: false,
    },
    {
        id: "SUB005",
        name: "EcoVentures Inc.",
        plan: { label: "Enterprise", color: "success" },
        status: { label: "Active", color: "success" },
        startDate: "Feb 1, 2024",
        endDate: "Feb 1, 2025",
        amount: "99.99 USD",
        autoRenew: false,
    },
    {
        id: "SUB006",
        name: "Community Arts Foundation",
        plan: { label: "Standard", color: "primary" },
        status: { label: "Expired", color: "danger" },
        startDate: "Jul 15, 2023",
        endDate: "Jul 14, 2024",
        amount: "29.99 USD",
        autoRenew: false,
    },
];

const SubscriptionSuper = () => {
    const [subscriptions, setSubscriptions] = useState(initialData);

    const toggleAutoRenew = (id) => {
        const updatedData = subscriptions.map((sub) =>
            sub.id === id ? { ...sub, autoRenew: !sub.autoRenew } : sub
        );
        setSubscriptions(updatedData);
    };

    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                        <div>
                            <h4 className="text-dark mb-1 d-flex align-items-center">
                                Subscription Management
                            </h4>
                            <p className="text-muted mb-0">
                                View and manage partner subscriptions and plans
                            </p>
                        </div>
                        <div className="d-flex gap-3 mt-2 mt-md-0">
                            <button className="btn btn-outline-primary d-flex align-items-center">
                                <MdFileDownload className="me-2" size={20} />
                                New Subcription
                            </button>
                            <button className="btn btn-primary d-flex align-items-center">
                                <MdFileDownload className="me-2" size={20} />
                                Export Request
                            </button>
                        </div>
                    </div>

                    <div className="d-flex align-items-center flex-wrap gap-2 mb-3 filter-box">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search ID, Customer, Service"
                        />
                        <select className="form-select">
                            <option>All Plans</option>
                            <option>Today</option>
                            <option>Last Week</option>
                            <option>Last Month</option>
                        </select>
                        <select className="form-select">
                            <option>All Statuses</option>
                            <option>Online Sales</option>
                            <option>Counter Sales</option>
                        </select>
                        <select className="form-select">
                            <option>Filter by Start Date</option>
                            <option>Online</option>
                            <option>Counter</option>
                        </select>
                        <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                            <BsArrowRepeat size={16} />
                            Clear Filters
                        </button>
                    </div>

                    <TableWrapper>
                        <div className="container p-0">
                            <table className="table table-bordered align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sub ID</th>
                                        <th>Partner Name</th>
                                        <th>Plan</th>
                                        <th>Status</th>
                                        <th>Start Date</th>
                                        <th>End/Next Bill</th>
                                        <th>Amount</th>
                                        <th>Auto-Renew</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subscriptions.map((item) => (
                                        <tr key={item.id}>
                                            <td className="fw-bold">{item.id}</td>
                                            <td>{item.name}</td>
                                            <td>
                                                <span className={`badge badge-${item.plan.color}`}>
                                                    {item.plan.label}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`badge badge-${item.status.color}`}>
                                                    {item.status.label}
                                                </span>
                                            </td>
                                            <td>{item.startDate}</td>
                                            <td>{item.endDate}</td>
                                            <td className="fw-bold">{item.amount}</td>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={item.autoRenew}
                                                    onChange={() => toggleAutoRenew(item.id)}
                                                />
                                            </td>
                                            <td>
                                                <BsThreeDotsVertical />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </TableWrapper>
                </div>
            </div>
        </Wrapper>
    );
};

export default SubscriptionSuper;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px !important;
  }
`;

const TableWrapper = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  /* Badge Common */
  .badge {
    display: inline-block;
    padding: 6px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  /* Badge Colors with 15% opacity bg */
  .badge-secondary {
    background-color: rgba(108, 117, 125, 0.15);
    color: #6c757d;
  }

  .badge-primary {
    background-color: rgba(13, 110, 253, 0.15);
    color: #0d6efd;
  }

  .badge-success {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }

  .badge-danger {
    background-color: rgba(220, 53, 69, 0.15);
    color: #dc3545;
  }

  .badge-warning {
    background-color: rgba(255, 193, 7, 0.15);
    color: #ffc107;
  }

  .badge-purple {
    background-color: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
  }
`;
